import { useState } from 'react';
import { userService } from '../../services/api';
import { Input, Select, Button, Toast } from '../../components/ui';

const EditUserForm = ({ user, roles, retailOUs, onClose, onUpdated }) => {
  const [form, setForm] = useState({
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    email: user.email || '',
    employeeId: user.employeeId || '',
    phone: user.phone || '',
    role: user.role?._id || user.role || '',
    retailOU: user.retailOU?._id || user.retailOU || '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const selectedRole = roles.find(r => r._id === form.role);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await userService.update(user._id, form);
      setToast({ msg: 'User updated successfully!', type: 'success' });
      if (onUpdated) onUpdated();
      setTimeout(onClose, 1500);
    } catch (err) {
      setToast({ msg: err.response?.data?.message || 'Error updating user', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const f = (field) => ({ value: form[field], onChange: e => setForm({ ...form, [field]: e.target.value }) });

  return (
    <div>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
          <Input label="First Name *" {...f('firstName')} placeholder="Enter first name" />
          <Input label="Last Name" {...f('lastName')} placeholder="Enter last name" />
          <Input label="Email *" {...f('email')} placeholder="Enter email" type="email" />
          <Input label="Employee ID" {...f('employeeId')} placeholder="e.g. EMP001" />
          <Input label="Phone" {...f('phone')} placeholder="Enter phone" />
          <Select label="Role *" {...f('role')} options={roles.map(r => ({ value: r._id, label: r.name }))} />
          {(selectedRole?.code === 'RETAIL_OU_LEAD' || selectedRole?.code === 'COUNSELLOR') && (
            <Select label="Retail OU" {...f('retailOU')} options={retailOUs.map(o => ({ value: o._id, label: o.name }))} />
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <Button variant="outline" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={loading}>Save Changes</Button>
        </div>
      </form>
    </div>
  );
};

export default EditUserForm;
